import { render, staticRenderFns } from "./ManterDashboardFormacaoView.vue?vue&type=template&id=5ae562f0&scoped=true"
import script from "./ManterDashboardFormacaoView.vue?vue&type=script&lang=js"
export * from "./ManterDashboardFormacaoView.vue?vue&type=script&lang=js"
import style0 from "./ManterDashboardFormacaoView.vue?vue&type=style&index=0&id=5ae562f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae562f0",
  null
  
)

export default component.exports